module.exports = __webpack_public_path__ + "img/headerbg1.2d9e8e75.png";